import { asyncThunkCreator, buildCreateSlice } from "@reduxjs/toolkit";

/**
 * `createSlice` variant with the async-thunk creator enabled, so slices can
 * declare thunks inline via the `create.asyncThunk` reducer creator.
 *
 * Kept in-app (rather than imported from `@covertree/new-business-redux`) so the
 * endorsement slices stay self-contained and don't break tests that mock that
 * package.
 */
export const createAsyncThunkSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});
